import React, { PropsWithChildren, useEffect, useState } from 'react';

const SectionPlaceholder: React.FunctionComponent<PropsWithChildren<{timeout?: number}>> = ({children, timeout}) => {

	const [_isLoading, setIsLoading] = useState<boolean>(true);

	useEffect(() => {
		let timer: NodeJS.Timeout;
		if(!!timeout) {
			timer = setTimeout(() => setIsLoading(false), timeout);
		}
		return () => {
			if(!!timer) clearTimeout(timer);
		}
	}, []);

	return _isLoading ? <div className="w-20 h-1 relative">
		<div className="w-full overflow-hidden absolute h-1 flex rounded bg-gray-200">
			<div className="w-full h-full animate-progressbar origin-[0%_50%] bg-gray-300"></div>
		</div>
	</div> : children
}

export default SectionPlaceholder;